import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

import { sxStyle } from './styles';

const AssistTimedModal = ({ onReloadSearch, searchResults }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (searchResults?.length > 0) {
      const hours = 2;
      const minutes = 59;
      const seconds = 0;

      const delay = (hours * 60 * 60 + minutes * 60 + seconds) * 1000;

      const timer = setTimeout(() => {
        setOpen(true);
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [searchResults]);

  const handleUpdate = () => {
    setOpen(false);
    onReloadSearch();
  };

  const handleClose = (_, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: sxStyle.paper }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h4" component="h2" sx={sxStyle.title}>
          Ha pasado mucho tiempo.
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="subtitle1" sx={sxStyle.subtitle}>
          Es posible que las tarifas hayan cambiado.
        </Typography>
      </DialogContent>

      <DialogActions sx={sxStyle.actions}>
        <Button
          onClick={handleUpdate}
          color="primary"
          variant="contained"
          sx={sxStyle.button}
        >
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssistTimedModal;
